import React from 'react';
import { FlexibleImageDisplay } from './flexible-image-display';
import { StandardCropData } from '@/modules/uiImages/types';
import { ImageIcon } from '@phosphor-icons/react';

interface SceneCoverImageProps {
  imageUrl?: string;
  imageCroppedUrl?: string;
  crop?: StandardCropData;
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  className?: string;
  showFallback?: boolean;
  fallbackIcon?: React.ReactNode;
  showCrop?: boolean;
}

export function SceneCoverImage({
  imageUrl,
  imageCroppedUrl,
  crop,
  size = 'lg',
  className = '',
  showFallback = true,
  fallbackIcon,
  showCrop = true
}: SceneCoverImageProps) {
  const getFallbackIcon = () => {
    if (fallbackIcon) return fallbackIcon;
    return <ImageIcon className="h-6 w-6 text-lureo-ink-subtlest" />;
  };

  return (
    <FlexibleImageDisplay
      imageUrl={imageUrl}
      imageCroppedUrl={imageCroppedUrl}
      crop={crop}
      imageCategory="SceneLandscape"
      size={size}
      className={className}
      showCrop={showCrop}
      fallbackIcon={showFallback ? getFallbackIcon() : undefined}
    />
  );
}
